import { AnalyticsBrowser } from '@segment/analytics-next';

const noop = () => {};
const noopAnalytics = {
  track: noop,
  page: noop,
  identify: noop,
  then: (cb) => cb([noopAnalytics]),
};

const isBrowser = typeof window !== 'undefined';
const writeKey = process.env.GATSBY_SEGMENT_ID || process.env.SEGMENT_ID;

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : undefined;
}

const fbCookiePlugin = {
  name: 'Facebook Cookie Enrichment',
  type: 'enrichment',
  version: '1.0.0',
  isLoaded: () => true,
  load: () => Promise.resolve(),
  track: (ctx) => {
    const fbp = getCookie('_fbp');
    const fbc = getCookie('_fbc');
    if (fbp) ctx.updateEvent('properties.fbp', fbp);
    if (fbc) ctx.updateEvent('properties.fbc', fbc);
    return ctx;
  },
  page: (ctx) => {
    const fbp = getCookie('_fbp');
    const fbc = getCookie('_fbc');
    if (fbp) ctx.updateEvent('properties.fbp', fbp);
    if (fbc) ctx.updateEvent('properties.fbc', fbc);
    return ctx;
  },
  identify: (ctx) => ctx,
};

export const analytics =
  isBrowser && writeKey
    ? AnalyticsBrowser.load(
        { writeKey, cdnURL: 'https://sapi.quashed.co.nz/cdn' },
        {
          integrations: {
            'Segment.io': {
              apiHost: 'sapi.quashed.co.nz/v1',
              protocol: 'https',
            },
          },
        },
      )
    : noopAnalytics;

// Register Facebook cookie enrichment plugin and expose on window
if (isBrowser) {
  analytics.then(([a]) => {
    a.register(fbCookiePlugin);
    window.analytics = a;
  });
}
